import {
  GO_TO_CREATE_NOTE,
  GO_TO_UPDATE_NOTE,
  GO_TO_DELETE_NOTE,
  GO_TO_IMPORT_NOTES,
  BACK,
  EDITOR_CHANGE,
  SHOW_PRIVATE_NOTES_TOGGLE,
  CREATE_NOTE,
  UPDATE_NOTE,
  DELETE_NOTE,
  UPDATE_PROPS,
  USE_TEMPLATE,
  LOADING,
  TOGGLE_NOTE_VISIBILITY
} from './actions'
import { buildNote } from './effects'

export const VIEWS = {
  INDEX: 'index',
  CREATE: 'create',
  FORM: 'form',
  DELETE: 'delete',
  IMPORT: 'import'
}

export default function reducer (state, { type, payload }) {
  switch (type) {
    case UPDATE_PROPS:
      return {
        ...state,
        notes: payload.props.notes,
        showPrivateNotes: state.showPrivateNotes ?? false,
      }
    case GO_TO_CREATE_NOTE:
      return {
        ...state,
        noteRichText: null,
        isPrivateNote: state.showPrivateNotes,
        view: VIEWS.CREATE,
        cameFrom: state.view,
        note: buildNote()
      }
    case GO_TO_UPDATE_NOTE:
      return {
        ...state,
        noteRichText: null,
        isPrivateNote: false,
        view: VIEWS.FORM,
        cameFrom: state.view,
        noteIndex: payload.noteIndex,
        note: buildNote(state.notes[payload.noteIndex])
      }
    case GO_TO_DELETE_NOTE:
      return {
        ...state,
        view: VIEWS.DELETE,
        cameFrom: state.view,
        noteIndex: payload.noteIndex,
      }
    case GO_TO_IMPORT_NOTES:
      return {
        ...state,
        view: VIEWS.IMPORT,
        cameFrom: state.view,
      }
    // Theres some performance issue here when clicking back
    case BACK:
      return {
        ...state,
        view: state.cameFrom,
        cameFrom: state.view
      }
    case EDITOR_CHANGE:
      return {
        ...state,
        noteRichText: payload.noteRichText
      }
    case TOGGLE_NOTE_VISIBILITY:
      return {
        ...state,
        isPrivateNote: !state.isPrivateNote
      }
    case SHOW_PRIVATE_NOTES_TOGGLE:
      return {
        ...state,
        showPrivateNotes: !state.showPrivateNotes
      }
    case CREATE_NOTE:
      return {
        ...state,
        view: VIEWS.INDEX,
        cameFrom: VIEWS.INDEX,
        loading: false,
        showPrivateNotes: state.isPrivateNote ?? state.showPrivateNotes
      }
    case UPDATE_NOTE:
      return {
        ...state,
        view: VIEWS.INDEX,
        cameFrom: state.INDEX,
        loading: false
      }
    case DELETE_NOTE:
      return {
        ...state,
        view: VIEWS.INDEX,
        cameFrom: state.INDEX,
        loading: false
      }
    case USE_TEMPLATE:
      return {
        ...state,
        noteTemplate: payload.template || undefined,
        noteRichText: payload.template?.content || ""
      }
    case LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return { ...state }
  }
}

export const propsToState = (props) => ({
  notes: props.notes,
  noteTemplates: props.noteTemplates,
  view: VIEWS.INDEX,
  cameFrom: VIEWS.INDEX,
  noteRichText: null,
  header: `Notes about this ${props.isScenarioPlanning ? 'plan' : 'scenario'}`,
})
